import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API}/engagement`;

export const submitFeedback = async (payload) => {
  const res = await axios.post(`${baseUrl}/feedback`, payload);
  return res.data;
};

export const submitReview = async (payload) => {
  const res = await axios.post(`${baseUrl}/review`, payload);
  return res.data;
};

export const getReviews = async () => {
  const res = await axios.get(`${baseUrl}/reviews`);
  return res.data;
};
